// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.section-box {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 90px;
  min-height: 90px;
  padding: 0.5rem;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  background: white;
  border-radius: 8px;
  border: 2px solid transparent;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
  position: relative;
  gap: 0.35rem;
}
.section-box.special-section {
  background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%);
  border: 2px dashed #ffa726;
}
.section-box.special-section .section-icon {
  color: #f57c00;
}
.section-box.special-section .section-name {
  color: #e65100;
  font-weight: 700;
}
.section-box.special-section:hover {
  background: linear-gradient(135deg, #ffe082 0%, #ffd54f 100%);
  box-shadow: 0 2px 8px rgba(255, 167, 38, 0.3);
}
.section-box.special-section.selected {
  background: linear-gradient(135deg, #ff6f00 0%, #f57c00 100%);
  border-color: #e65100;
}
.section-box.special-section.selected .section-icon {
  color: white;
}
.section-box.special-section.selected .section-name {
  color: white;
}
.section-box:hover {
  background: linear-gradient(135deg, #f8f9ff 0%, #e9ecff 100%);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);
  transform: translateY(-2px);
}
.section-box:hover .actions {
  display: flex;
}
.section-box.selected {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);
}
.section-box.selected .section-icon {
  color: white;
}
.section-box.selected .section-name {
  color: white;
}
.section-box.selected .child-count {
  background: rgba(255, 255, 255, 0.3);
  color: white;
}
.section-box.selected .actions ion-icon {
  color: white;
}
.section-box .section-image-wrapper {
  width: 40px;
  height: 40px;
  border-radius: 6px;
  overflow: hidden;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);
  flex-shrink: 0;
}
.section-box .section-image-wrapper .section-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}
.section-box .section-icon {
  font-size: 2rem;
  color: #667eea;
  flex-shrink: 0;
}
.section-box .section-name {
  font-size: 0.7rem;
  font-weight: 600;
  text-align: center;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  line-height: 1.2;
  width: 100%;
}
.section-box .section-name .item-count {
  font-size: 0.65rem;
  font-weight: 400;
  color: #764ba2;
  margin-left: 0.2rem;
}
.section-box .edit-input {
  width: 100%;
  padding: 0.25rem;
  border: 2px solid #667eea;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 500;
  outline: none;
  text-align: center;
}
.section-box .edit-input:focus {
  border-color: #764ba2;
  box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
}
.section-box .child-count {
  position: absolute;
  top: 4px;
  right: 4px;
  font-size: 0.65rem;
  font-weight: 700;
  color: #667eea;
  background: rgba(102, 126, 234, 0.15);
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  min-width: 20px;
  text-align: center;
}
.section-box .item-child-count {
  top: 4px;
  left: 4px;
  right: auto;
}
.section-box .actions {
  display: none;
  position: absolute;
  bottom: 4px;
  right: 4px;
  gap: 0.25rem;
  background: rgba(255, 255, 255, 0.95);
  padding: 0.2rem;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.section-box .actions ion-icon {
  color: #667eea;
  opacity: 0.7;
  transition: all 0.2s;
  font-size: 1rem;
}
.section-box .actions ion-icon:hover {
  opacity: 1;
  transform: scale(1.15);
}`, "",{"version":3,"sources":["webpack://./src/app/shaps/pages/catalog-admin/catalog-manager/section-box/section-box.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;EACA,gBAAA;EACA,eAAA;EACA,eAAA;EACA,iDAAA;EACA,iBAAA;EACA,kBAAA;EACA,6BAAA;EACA,yCAAA;EACA,kBAAA;EACA,YAAA;AACF;AACE;EACE,6DAAA;EACA,0BAAA;AACJ;AACI;EACE,cAAA;AACN;AAEI;EACE,cAAA;EACA,gBAAA;AAAN;AAGI;EACE,6DAAA;EACA,6CAAA;AADN;AAII;EACE,6DAAA;EACA,qBAAA;AAFN;AAIM;EACE,YAAA;AAFR;AAKM;EACE,YAAA;AAHR;AAQE;EACE,6DAAA;EACA,+CAAA;EACA,2BAAA;AANJ;AAQI;EACE,aAAA;AANN;AAUE;EACE,6DAAA;EACA,YAAA;EACA,+CAAA;AARJ;AAUI;EACE,YAAA;AARN;AAWI;EACE,YAAA;AATN;AAYI;EACE,oCAAA;EACA,YAAA;AAVN;AAaI;EACE,YAAA;AAXN;AAeE;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,6DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,cAAA;AAbJ;AAeI;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAbN;AAiBE;EACE,eAAA;EACA,cAAA;EACA,cAAA;AAfJ;AAkBE;EACE,iBAAA;EACA,gBAAA;EACA,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,oBAAA;EACA,qBAAA;EACA,4BAAA;EACA,gBAAA;EACA,WAAA;AAhBJ;AAkBI;EACE,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,mBAAA;AAhBN;AAoBE;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,kBAAA;AAlBJ;AAoBI;EACE,qBAAA;EACA,8CAAA;AAlBN;AAsBE;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;EACA,cAAA;EACA,qCAAA;EACA,wBAAA;EACA,mBAAA;EACA,eAAA;EACA,kBAAA;AApBJ;AAsBE;EACE,QAAA;EACA,SAAA;EACA,WAAA;AApBJ;AAuBE;EACE,aAAA;EACA,kBAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,qCAAA;EACA,eAAA;EACA,kBAAA;EACA,yCAAA;AArBJ;AAuBI;EACE,cAAA;EACA,YAAA;EACA,oBAAA;EACA,eAAA;AArBN;AAuBM;EACE,UAAA;EACA,sBAAA;AArBR","sourcesContent":[".section-box {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  width: 90px;\n  min-height: 90px;\n  padding: 0.5rem;\n  cursor: pointer;\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n  background: white;\n  border-radius: 8px;\n  border: 2px solid transparent;\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);\n  position: relative;\n  gap: 0.35rem;\n\n  &.special-section {\n    background: linear-gradient(135deg, #fff8e1 0%, #ffe082 100%);\n    border: 2px dashed #ffa726;\n    \n    .section-icon {\n      color: #f57c00;\n    }\n    \n    .section-name {\n      color: #e65100;\n      font-weight: 700;\n    }\n    \n    &:hover {\n      background: linear-gradient(135deg, #ffe082 0%, #ffd54f 100%);\n      box-shadow: 0 2px 8px rgba(255, 167, 38, 0.3);\n    }\n    \n    &.selected {\n      background: linear-gradient(135deg, #ff6f00 0%, #f57c00 100%);\n      border-color: #e65100;\n      \n      .section-icon {\n        color: white;\n      }\n      \n      .section-name {\n        color: white;\n      }\n    }\n  }\n\n  &:hover {\n    background: linear-gradient(135deg, #f8f9ff 0%, #e9ecff 100%);\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15);\n    transform: translateY(-2px);\n\n    .actions {\n      display: flex;\n    }\n  }\n\n  &.selected {\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    color: white;\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.4);\n\n    .section-icon {\n      color: white;\n    }\n\n    .section-name {\n      color: white;\n    }\n\n    .child-count {\n      background: rgba(255, 255, 255, 0.3);\n      color: white;\n    }\n\n    .actions ion-icon {\n      color: white;\n    }\n  }\n\n  .section-image-wrapper {\n    width: 40px;\n    height: 40px;\n    border-radius: 6px;\n    overflow: hidden;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.25);\n    flex-shrink: 0;\n\n    .section-image {\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n    }\n  }\n\n  .section-icon {\n    font-size: 2rem;\n    color: #667eea;\n    flex-shrink: 0;\n  }\n\n  .section-name {\n    font-size: 0.7rem;\n    font-weight: 600;\n    text-align: center;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: -webkit-box;\n    -webkit-line-clamp: 2;\n    -webkit-box-orient: vertical;\n    line-height: 1.2;\n    width: 100%;\n\n    .item-count {\n      font-size: 0.65rem;\n      font-weight: 400;\n      color: #764ba2;\n      margin-left: 0.2rem;\n    }\n  }\n\n  .edit-input {\n    width: 100%;\n    padding: 0.25rem;\n    border: 2px solid #667eea;\n    border-radius: 4px;\n    font-size: 0.7rem;\n    font-weight: 500;\n    outline: none;\n    text-align: center;\n\n    &:focus {\n      border-color: #764ba2;\n      box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);\n    }\n  }\n\n  .child-count {\n    position: absolute;\n    top: 4px;\n    right: 4px;\n    font-size: 0.65rem;\n    font-weight: 700;\n    color: #667eea;\n    background: rgba(102, 126, 234, 0.15);\n    padding: 0.15rem 0.35rem;\n    border-radius: 10px;\n    min-width: 20px;\n    text-align: center;\n  }\n  .item-child-count {\n    top: 4px;\n    left: 4px;\n    right: auto;\n  }\n\n  .actions {\n    display: none;\n    position: absolute;\n    bottom: 4px;\n    right: 4px;\n    gap: 0.25rem;\n    background: rgba(255, 255, 255, 0.95);\n    padding: 0.2rem;\n    border-radius: 4px;\n    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\n\n    ion-icon {\n      color: #667eea;\n      opacity: 0.7;\n      transition: all 0.2s;\n      font-size: 1rem;\n\n      &:hover {\n        opacity: 1;\n        transform: scale(1.15);\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
